import React from "react"
import { getCssSizeValue, getItemType, getMapKey, getPaddingsClassFromData } from "@/utils/utils"
import GridContainer from "@/components/common/GridContainer"
import { CONTENT_TYPES } from "@/constants"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { useIsMobile } from "@/hooks/useDevice"
import Statistic from "@/components/Stats/Statistic"
import StatisticGroup from "@/components/Stats/StatisticGroup"

const Wrapper = styled(GridContainer)`
	@media (max-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET] - 1}px) {
		//grid-template-columns: 1fr;
		--mobile-row-gap: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
		row-gap: var(--mobile-row-gap);
	}
`

// const Statistic = dynamic(import("@/components/Stats/Statistic"), {
// 	ssr: false,
// 	loading: () => <Loading />,
// })
// const StatisticGroup = dynamic(import("@/components/Stats/StatisticGroup"), {
// 	ssr: false,
// 	loading: () => <Loading />,
// })

const Content = ({ data }) => {
	const type = getItemType(data)
	switch (type) {
		case CONTENT_TYPES.STATISTIC_GROUP:
			// return null
			return <StatisticGroup data={data} />
		case CONTENT_TYPES.STATISTIC:
			return <Statistic data={data} />
		default:
			return null
	}
}

const Stats = ({ data, className = "", ...props }) => {
	const paddings = getPaddingsClassFromData(data)
	const id = data?.id || ""
	const statistics = data?.statistics || []
	const isMobile = useIsMobile()
	return (
		<Wrapper id={id} className={`${className} ${paddings} no-margin ${!isMobile ? " padding" : ""} `} {...props}>
			{statistics.map((item, index) => (
				<Content data={item} key={getMapKey(item, index)} />
			))}
		</Wrapper>
	)
}

export default Stats